import { render, staticRenderFns } from "./LandPageParceiro.vue?vue&type=template&id=bc44fac2&scoped=true"
import script from "./LandPageParceiro.vue?vue&type=script&lang=js"
export * from "./LandPageParceiro.vue?vue&type=script&lang=js"
import style0 from "./LandPageParceiro.vue?vue&type=style&index=0&id=bc44fac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc44fac2",
  null
  
)

export default component.exports